/**
 * Copyright © 2025 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import {
  mapRouteToRelativePath,
  getRelativeRouteWithQueryParams,
  getRoute,
} from '../../util/routing';
import { CART_ROUTE_NAME } from '../cart/cart.routes';

export const PRODUCTS_ROUTE_NAME = 'products';
export const PRODUCTS_ROUTE = mapRouteToRelativePath(PRODUCTS_ROUTE_NAME);

export const PRODUCTS_TAB_0_ROUTE = getRelativeRouteWithQueryParams(PRODUCTS_ROUTE_NAME, {
  tab: 0,
});

export const PRODUCTS_CART_ROUTE = getRoute(PRODUCTS_ROUTE_NAME, CART_ROUTE_NAME);
